// extracted by mini-css-extract-plugin
export default {"form":"update-profile-form_form__OlxGE","choice":"update-profile-form_choice__soKqy"};